import { getPublicPath } from '../environment';
import { TENANT_QUERY_PARAM } from './constants';

export const navigateToHomepage = (tenantId?: number): void => {
  const queryParam = tenantId ? `?${TENANT_QUERY_PARAM}=${tenantId}` : '';
  location.href = `${getPublicPath() + queryParam}`;
};
